<template>
  <div class="content">
    <el-breadcrumb separator-class="el-icon-arrow-right color3">
      <!-- <el-breadcrumb-item class="progressItem"></el-breadcrumb-item> -->
      <el-breadcrumb-item :to="{ path: '/dustPro' }">扬尘监测统计</el-breadcrumb-item>
      <el-breadcrumb-item>数据统计</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="progress-CURD">
      <div class="progress-bar">
        <!-- <el-button type="primary" class="ssjc-btn" @click="addRow()">实时监测</el-button> -->
        <div class="progress-tit-con">
          <!-- <el-select class="progress-width" v-model="progress">
            <el-option
              v-for="item in groups"
              :key="item.id"
              :label="item.description"
              :value="item.id"
            ></el-option>
          </el-select> -->
          <div class="block">
            <el-date-picker
              v-model="value1"
              type="daterange"
              align="right"
              unlink-panels
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              class="block-ele"
              value-format="yyyy-MM-dd"
              @change="doFilter"
            ></el-date-picker>
          </div>
        </div>
      </div>
      <div class="progress-con">
        <div class="echart">
          <div id="echart" style="width:100%;height:100%;"></div> 
        </div>
      </div>
    </div>

    <!-- 新增窗口 -->
    <el-dialog
      :title="dialogTitle"
      :visible.sync="addFormVisible"
      center
      :append-to-body="true"
      :lock-scroll="false"
      class="add-form"
      width="60%"
    >
      <div class="dust-crane">
        <el-table :data="tableData" border style="width: 100%">
          <el-table-column label="类别">
            <template slot-scope="scope">
              <i class="el-icon-time"></i>
              <span style="margin-left: 10px">{{ scope.row.type }}</span>
            </template>
          </el-table-column>
          <el-table-column label="指数">
            <template slot-scope="scope">
              <span style="margin-left: 10px">{{ scope.row.bz }}</span>
            </template>
          </el-table-column>
          <el-table-column label="标准">
            <template slot-scope="scope">
              <span style="margin-left: 10px">{{ scope.row.bz }}</span>
            </template>
          </el-table-column>
          <el-table-column label="描述">
            <template slot-scope="scope">
              <span style="margin-left: 10px">{{ scope.row.ms }}</span>
            </template>
          </el-table-column>
          <el-table-column label="时间">
            <template slot-scope="scope">
              <span style="margin-left: 10px">{{ scope.row.update }}</span>
            </template>
          </el-table-column>
          <!-- <el-table-column prop="ms" label="描述"></el-table-column>
          <el-table-column prop="updata" label="时间"></el-table-column>-->
        </el-table>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import echarts from 'echarts' //引入echarts

import myHttp from '../../untils/port.js'
import util from '../../untils/util.js'
import base from '../../untils/base.js'

var _index
export default {
  data() {
    return {
      value1: [], // 开始日期/结束日期
      groups: [{ progress: '' }], // 下拉菜单组 
      progress: '', // 下拉菜单数据
      // updateDate: '',
      // pm2: '',
      // pm10: '',
      // windSpeed: '',
      // windDirection: '',
      // temperature: '',
      // humidity: '',
      // noise: '',
      addForm: [], // 新增窗口数组
      listData: [], // 原接口数据数组，本页面现无作用
      tableData: [ 
        // {
        //   type: 'PM2.5',
        //   imgUrl: '',
        //   num: '',
        //   bz: '100 μg/m3',
        //   ms: '正常',
        //   update: ''
        // },
        // {
        //   type: 'PM10',
        //   imgUrl: '',
        //   num: '',
        //   bz: '100 μg/m3',
        //   ms: '预警'
        // },
        // {
        //   type: '风速',
        //   imgUrl: '',
        //   num: '',
        //   bz: '-- m/s',
        //   ms: '正常'
        // },
        // {
        //   type: '风向',
        //   imgUrl: '',
        //   num: '',
        //   bz: '',
        //   ms: '正常'
        // },
        // {
        //   type: '温度',
        //   imgUrl: '',
        //   num: '',
        //   bz: '40℃',
        //   ms: '正常'
        // },
        // {
        //   type: '湿度',
        //   imgUrl: '',
        //   num: '',
        //   bz: '100 %RH',
        //   ms: '正常'
        // },
        // {
        //   type: '噪音',
        //   imgUrl: '',
        //   num: '',
        //   bz: '58.7 dB',
        //   ms: '预警'
        // }
      ], // 新增窗口表单数据
      dialogTitle: '编辑窗口', //弹出框标题
      addFormVisible: false, // 新增窗口不显示
      groupId: util.session.get('groupId'),
      config:{
        pm2:'',
        pm10:'',
        noise:'',
        temperature:'',
        humidity:'',
        windSpeed:''
      },
      startDate:util.myTime.getweekDate(5)[0],
      entDate:util.myTime.getweekDate(5)[1],
      warnVal:{pm2Warning:75,pm10Warning:150,noiseWarning:70,temperatureWarning:0,humidityWarning:0,windSpeedWarning:0},
    }
  },
  // watch: {
  //   groupId: {
  //     handler(newVal) {
  //       this.getDataLine()
  //     },
  //     deep: true
  //   }
  // },
  mounted() {
    this.value1.push(util.myTime.getDateByDays(new Date(),-30))
    this.value1.push(util.myTime.getCurTime())
    this.startDate = this.value1[0]
    this.entDate = this.value1[1]
    this.getDataLine()
    //this.getCurData()
    this.getConfig()
  },
  methods: {
    //搜索
    doFilter(){
      //console.log(this.value1)
      this.startDate = this.value1[0]
      this.entDate = this.value1[1]
      this.getDataLine()
    },
    //获取标准
    getConfig(){
      //获取标准
      var that =this 
      myHttp.selectDustConfig({
        projectId:util.session.get('groupId')
      }).then(function(resp){
        if(resp.data.code=='200'){
          var data = resp.data.data
          if(data){
            that.config = data
          }
        }
      })
    },
    // eChart 接口
    getDataLine() {
      // 数据统计
      let that = this
      myHttp.getWeekByProjectId({
          projectId: util.session.get('groupId'),
          startDate:this.startDate,
          entDate:this.entDate,
      }).then(
          function(resp) {
            if (resp.data.code == '200') {
              var list = resp.data.data.Dust || []
              var result = [[],[],[],[],[],[]]
              var min = [[],[],[],[],[],[]]
              for (var i = 0; i < list.length; i++) {
                // list[i].index = (that.currentPage - 1) * that.pageSize + (i + 1)
                var pm2 = list[i].pm2?list[i].pm2:0
                var pm10 = list[i].pm10?list[i].pm10:0
                var windSpeed = list[i].windSpeed?list[i].windSpeed:0
                var temperature = list[i].temperature?list[i].temperature:0
                var humidity = list[i].humidity?list[i].humidity:0
                var noise = list[i].noise?list[i].noise:0
                result[0].push(pm2)
                result[1].push(pm10)
                result[2].push(noise)
                result[3].push(temperature)
                result[4].push(humidity)
                result[5].push(windSpeed)
                
                min[0].push(list[i].pm2Min?list[i].pm2Min:0)
                min[1].push(list[i].pm10Min?list[i].pm10Min:0)
                min[2].push(list[i].noiseMin?list[i].noiseMin:0)
                min[3].push(list[i].temperatureMin?list[i].temperatureMin:0)
                min[4].push(list[i].humidityMin?list[i].humidityMin:0)
                min[5].push(list[i].windSpeedMin?list[i].windSpeedMin:0)
              }
              that.warnVal.pm2Warning = list[0].pm2Warning 
              that.warnVal.pm10Warning = list[0].pm10Warning
              that.warnVal.noiseWarning = list[0].noiseWarning
              that.warnVal.temperatureWarning = list[0].temperatureWarning
              that.warnVal.humidityWarning = list[0].humidityWarning
              that.warnVal.windSpeedWarning = list[0].windSpeedWarning
              that.setChart(result,min)
              that.groups = list
              that.listData = list[0]
            } else {
              that.$message.error(resp.msg)
            }
          },
          function() {}
        )
    },

    // 数据统计  eChart
    setChart(data,min) {
      var week = this.getSevenDay(this.entDate,util.myTime.getdayByDate(this.startDate,this.entDate)+1)
      var that = this
      var option = {
        tooltip: {
          trigger: 'axis',
            axisPointer: {
                type: 'cross',
            },
            backgroundColor:'#F3F3F3',
            borderWidth:'1',
            formatter(params){
              var content = '<p style="height:40px;color:#707070;font-size:0.9vw;"> '+params[0].name+'</p>'
              //pm2
              content += '<div style="height:60px;display:flex;justify-content: flex-start;align-content: center;align-items: center;">'
              +'<div style="width:60px;height:100%;color:#707070;font-size:14px;line-height: 60px;">'+params[0].seriesName+'</div>'
              +'<div style="width:160px;height:100%;border-bottom: 1px solid #ddd;color:#707070;">'
              if(parseFloat(params[0].value) < parseFloat(that.warnVal.pm2Warning)){
                content +='<p style="height:30px;width:100%;font-size:14px;line-height: 30px;text-align: left;">最高值：<span style="font-size:14px;color:#67C23A;">'+params[0].value+'μg/m³</span></p>'
              }else{
                content +='<p style="height:30px;width:100%;font-size:14px;line-height: 30px;text-align: left;">最高值：<span style="font-size:14px;color:#F56C6C;">'+params[0].value+'μg/m³</span></p>'
              }
              if(parseFloat(min[0][params[0].dataIndex]) < parseFloat(that.warnVal.pm2Warning)){
                content +='<p style="height:30px;width:100%;font-size:14px;line-height: 30px;text-align: left;">最低值：<span style="font-size:14px;color:#67C23A;">'+min[0][params[0].dataIndex]+'μg/m³</span></p></div>'
              }else{
                content +='<p style="height:30px;width:100%;font-size:14px;line-height: 30px;text-align: left;">最低值：<span style="font-size:14px;color:#F56C6C;">'+min[0][params[0].dataIndex]+'μg/m³</span></p></div>'
              }
              content +='<div style="width:80px;height:100%;color:#707070;font-size:14px;line-height: 60px;color:#F56C6C;text-align: left;">('+that.warnVal.pm2Warning+'μg/m³)</div>'
              +'</div>'
              //pm10
              content += '<div style="height:60px;display:flex;justify-content: flex-start;align-content: center;align-items: center;">'
              +'<div style="width:60px;height:100%;color:#707070;font-size:14px;line-height: 60px;">'+params[1].seriesName+'</div>'
              +'<div style="width:160px;height:100%;border-bottom: 1px solid #ddd;color:#707070;">'
              if(parseFloat(params[1].value) < parseFloat(that.warnVal.pm10Warning)){
                content +='<p style="height:30px;width:100%;font-size:14px;line-height: 30px;text-align: left;">最高值：<span style="font-size:14px;color:#67C23A;">'+params[1].value+'μg/m³</span></p>'
              }else{
                content +='<p style="height:30px;width:100%;font-size:14px;line-height: 30px;text-align: left;">最高值：<span style="font-size:14px;color:#F56C6C;">'+params[1].value+'μg/m³</span></p>'
              }
              if(parseFloat(min[1][params[1].dataIndex]) < parseFloat(that.warnVal.pm10Warning)){
                content +='<p style="height:30px;width:100%;font-size:14px;line-height: 30px;text-align: left;">最低值：<span style="font-size:14px;color:#67C23A;">'+min[1][params[1].dataIndex]+'μg/m³</span></p></div>'
              }else{
                content +='<p style="height:30px;width:100%;font-size:14px;line-height: 30px;text-align: left;">最低值：<span style="font-size:14px;color:#F56C6C;">'+min[1][params[1].dataIndex]+'μg/m³</span></p></div>'
              }
              content +='<div style="width:80px;height:100%;color:#707070;font-size:14px;line-height: 60px;color:#F56C6C;text-align: left;">('+that.warnVal.pm10Warning+'μg/m³)</div>'
              +'</div>'
              //噪音
              content += '<div style="height:60px;display:flex;justify-content: flex-start;align-content: center;align-items: center;">'
              +'<div style="width:60px;height:100%;color:#707070;font-size:14px;line-height: 60px;">'+params[2].seriesName+'</div>'
              +'<div style="width:160px;height:100%;border-bottom: 1px solid #ddd;color:#707070;">'
              if(parseFloat(params[2].value) < parseFloat(that.warnVal.noiseWarning)){
                content +='<p style="height:30px;width:100%;font-size:14px;line-height: 30px;text-align: left;">最高值：<span style="font-size:14px;color:#67C23A;">'+params[2].value+'dB</span></p>'
              }else{
                content +='<p style="height:30px;width:100%;font-size:14px;line-height: 30px;text-align: left;">最高值：<span style="font-size:14px;color:#F56C6C;">'+params[2].value+'dB</span></p>'
              }
              if(parseFloat(min[2][params[2].dataIndex]) < parseFloat(that.warnVal.noiseWarning)){
                content +='<p style="height:30px;width:100%;font-size:14px;line-height: 30px;text-align: left;">最低值：<span style="font-size:14px;color:#67C23A;">'+min[2][params[2].dataIndex]+'dB</span></p></div>'
              }else{
                content +='<p style="height:30px;width:100%;font-size:14px;line-height: 30px;text-align: left;">最低值：<span style="font-size:14px;color:#F56C6C;">'+min[2][params[2].dataIndex]+'dB</span></p></div>'
              }
              content +='<div style="width:80px;height:100%;color:#707070;font-size:14px;line-height: 60px;color:#F56C6C;text-align: left;">('+that.warnVal.noiseWarning+'dB)</div>'
              +'</div>'
              //温度
              content += '<div style="height:60px;display:flex;justify-content: flex-start;align-content: center;align-items: center;">'
              +'<div style="width:60px;height:100%;color:#707070;font-size:14px;line-height: 60px;">'+params[3].seriesName+'</div>'
              +'<div style="width:160px;height:100%;border-bottom: 1px solid #ddd;color:#707070;">'
              if(parseFloat(params[3].value) < parseFloat(that.warnVal.temperatureWarning)||that.warnVal.temperatureWarning==0){
                content +='<p style="height:30px;width:100%;font-size:14px;line-height: 30px;text-align: left;">最高值：<span style="font-size:14px;color:#67C23A;">'+params[3].value+'℃</span></p>'
              }else{
                content +='<p style="height:30px;width:100%;font-size:14px;line-height: 30px;text-align: left;">最高值：<span style="font-size:14px;color:#F56C6C;">'+params[3].value+'℃</span></p>'
              }
              if(parseFloat(min[3][params[3].dataIndex]) < parseFloat(that.warnVal.temperatureWarning)||that.warnVal.temperatureWarning==0){
                content +='<p style="height:30px;width:100%;font-size:14px;line-height: 30px;text-align: left;">最低值：<span style="font-size:14px;color:#67C23A;">'+min[3][params[3].dataIndex]+'℃</span></p></div>'
              }else{
                content +='<p style="height:30px;width:100%;font-size:14px;line-height: 30px;text-align: left;">最低值：<span style="font-size:14px;color:#F56C6C;">'+min[3][params[3].dataIndex]+'℃</span></p></div>'
              }
              content +='<div style="width:80px;height:100%;color:#707070;font-size:14px;line-height: 60px;color:#F56C6C;text-align: left;">('+that.warnVal.temperatureWarning+'℃)</div>'
              +'</div>'
              //湿度
              content += '<div style="height:60px;display:flex;justify-content: flex-start;align-content: center;align-items: center;">'
              +'<div style="width:60px;height:100%;color:#707070;font-size:14px;line-height: 60px;">'+params[4].seriesName+'</div>'
              +'<div style="width:160px;height:100%;border-bottom: 1px solid #ddd;color:#707070;">'
              if(parseFloat(params[4].value) < parseFloat(that.warnVal.humidityWarning)||that.warnVal.humidityWarning==0){
                content +='<p style="height:30px;width:100%;font-size:14px;line-height: 30px;text-align: left;">最高值：<span style="font-size:14px;color:#67C23A;">'+params[4].value+'%</span></p>'
              }else{
                content +='<p style="height:30px;width:100%;font-size:14px;line-height: 30px;text-align: left;">最高值：<span style="font-size:14px;color:#F56C6C;">'+params[4].value+'%/span></p>'
              }
              if(parseFloat(min[4][params[4].dataIndex]) < parseFloat(that.warnVal.humidityWarning)||that.warnVal.humidityWarning==0){
                content +='<p style="height:30px;width:100%;font-size:14px;line-height: 30px;text-align: left;">最低值：<span style="font-size:14px;color:#67C23A;">'+min[4][params[4].dataIndex]+'%</span></p></div>'
              }else{
                content +='<p style="height:30px;width:100%;font-size:14px;line-height: 30px;text-align: left;">最低值：<span style="font-size:14px;color:#F56C6C;">'+min[4][params[4].dataIndex]+'%</span></p></div>'
              }
              content +='<div style="width:80px;height:100%;color:#707070;font-size:14px;line-height: 60px;color:#F56C6C;text-align: left;">('+that.warnVal.humidityWarning+'%)</div>'
              +'</div>'
              //风速
              content += '<div style="height:60px;display:flex;justify-content: flex-start;align-content: center;align-items: center;">'
              +'<div style="width:60px;height:100%;color:#707070;font-size:14px;line-height: 60px;">'+params[5].seriesName+'</div>'
              +'<div style="width:160px;height:100%;border-bottom: 1px solid #ddd;color:#707070;">'
              if(parseFloat(params[5].value) < parseFloat(that.warnVal.windSpeedWarning)||that.warnVal.windSpeedWarning==0){
                content +='<p style="height:30px;width:100%;font-size:14px;line-height: 30px;text-align: left;">最高值：<span style="font-size:14px;color:#67C23A;">'+params[5].value+'m/s</span></p>'
              }else{
                content +='<p style="height:30px;width:100%;font-size:14px;line-height: 30px;text-align: left;">最高值：<span style="font-size:14px;color:#F56C6C;">'+params[5].value+'m/s</span></p>'
              }
              if(parseFloat(min[5][params[5].dataIndex]) < parseFloat(that.warnVal.windSpeedWarning)||that.warnVal.windSpeedWarning==0){
                content +='<p style="height:30px;width:100%;font-size:14px;line-height: 30px;text-align: left;">最低值：<span style="font-size:14px;color:#67C23A;">'+min[5][params[5].dataIndex]+'m/s</span></p></div>'
              }else{
                content +='<p style="height:30px;width:100%;font-size:14px;line-height: 30px;text-align: left;">最低值：<span style="font-size:14px;color:#F56C6C;">'+min[5][params[5].dataIndex]+'m/s</span></p></div>'
              }
              content +='<div style="width:80px;height:100%;color:#707070;font-size:14px;line-height: 60px;color:#F56C6C;text-align: left;">('+that.warnVal.windSpeedWarning+'m/s)</div>'
              +'</div>'
              
              return content
            }
        },
        legend: {
          data: ['PM2.5', 'PM10', '噪音', '温度', '湿度', '风速']
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        toolbox: {
          feature: {
            saveAsImage: {}
          }
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: week
        },
        yAxis: {
          type: 'value'
        },
        series: [
          {
            name: 'PM2.5',
            type: 'line',
            data: data[0]
          },
          {
            name: 'PM10',
            type: 'line',
            data: data[1]
          },
          {
            name: '噪音',
            type: 'line',
            data: data[2]
          },
          {
            name: '温度',
            type: 'line',
            data: data[3]
          },
          {
            name: '湿度',
            type: 'line',
            data: data[4]
          },
          {
            name: '风速',
            type: 'line',
            data: data[5]
          }
        ]
      }
      var page = this.$echarts.init(document.getElementById('echart'))
      page.setOption(option)
    },

    getSevenDay(day,num){
      var start = new Date();
      var obj = day?new Date(day):new Date()
      var list = []
      for(var i=0;i<num;i++){
        start.setTime(obj.getTime() - 3600 * 1000 * 24 * i);
        var ent = util.myTime.formatTime(start,'YYYY-MM-dd')
        list.push(ent)
      }
      return list.reverse()
    },

    //获取当前数据
    getCurData(){
      var that = this
      myHttp.getDustAllByCur({
        projectId:this.groupId
      }).then(function(resp){
        if(resp.data.code=='200'){
          var data = resp.data.data
          data.windSpeed = data.windSpeed?data.windSpeed:0
          var pm2Flag = that.config&&that.config.pm2&&that.config.pm2!=''?(parseFloat(data.pm2)>parseFloat(that.config.pm2)?'预警':'正常'):''
          var pm10Flag = that.config&&that.config.pm2&&that.config.pm2!=''?(parseFloat(data.pm10)>parseFloat(that.config.pm10)?'预警':'正常'):''
          var speedFlag = that.config&&that.config.windSpeed&&that.config.windSpeed!=''?(parseFloat(data.windSpeed)>parseFloat(that.config.windSpeed)?'预警':'正常'):''
          var temperatureFlag = that.config&&that.config.temperature&&that.config.temperature!=''?(parseFloat(data.temperature)>parseFloat(that.config.temperature)?'预警':'正常'):''
          var humidityFlag = that.config&&that.config.humidity&&that.config.humidity!=''?(parseFloat(data.humidity)>parseFloat(that.config.humidity)?'预警':'正常'):''
          var noiseFlag = that.config&&that.config.noise&&that.config.noise!=''?(parseFloat(data.noise)>parseFloat(that.config.noise)?'预警':'正常'):''
          that.tableData = [ 
            {
              type: 'PM2.5',
              imgUrl: '',
              num: data.pm2+' μg/m3',
              bz: that.config.pm2+' μg/m3',
              ms: pm2Flag,
              update: ''
            },
            {
              type: 'PM10',
              imgUrl: '',
              num: data.pm10+' μg/m3',
              bz: that.config.pm10 +' μg/m3',
              ms: pm10Flag
            },
            {
              type: '风速',
              imgUrl: '',
              num: data.windSpeed+' m/s',
              bz: that.config.windSpeed+' m/s',
              ms: speedFlag
            },
            {
              type: '风向',
              imgUrl: '',
              num: '',
              bz: '',
              ms: ''
            },
            {
              type: '温度',
              imgUrl: '',
              num: data.temperature+'℃',
              bz: that.config.temperature+' ℃',
              ms: temperatureFlag
            },
            {
              type: '湿度',
              imgUrl: '',
              num: data.humidity+' %RH',
              bz: that.config.humidity+' %RH',
              ms: humidityFlag
            },
            {
              type: '噪音',
              imgUrl: '',
              num: data.noise+' dB',
              bz: that.config.noise+' dB',
              ms: noiseFlag
            }
          ]
        }
      })
      
    },

    /**
     * 新增设备
     */
    addRow() {
      this.dialogTitle = '实时监测'
      this.addFormVisible = true
      this.getCurData()
    }
  }
}
</script>

<style scoped>
* {
  margin: 0;
  box-sizing: border-box;
}

.content {
  overflow: hidden;
  box-sizing: border-box;
}

.el-breadcrumb {
  line-height: 30px;
  margin-bottom: 10px;
}

.progressItem {
  font-weight: 0;
  font-size: 17px;
}

.progress-CURD {
  width: 100%;
  height: calc( 100% - 30px );
  background-color: #fff;
  position: relative;
}

.progress-bar {
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 80px;
  border-top: 3px solid rgb(224, 224, 224);
  border-bottom: 3px solid #17b2fe;
}

.ssjc-btn {
  margin-left: 20px;
  background: #009688;
  border: 1px solid #009688;
}

.progress-tit-con {
  margin: 0 auto;
}

.progress-width {
  width: 200px;
}

.block {
  display: inline;
  margin-left: 20px;
}

.block-ele {
  width: 380px;
}

.progress-con {
  width: 100%;
  height: calc( 100% - 80px );
  padding: 0 10px;
  padding-top: 10px;
  background: #fff;
}
.progress-con .echart{
  width: 100%;
  height: 100%;
  position: relative;
}
/* 
.echart {
  background: darkcyan;
} */

.add-form {
 margin-top: 10vh;
}

.tower-crane {
 overflow: hidden;
 padding-bottom: 2%;
}

.tower-crane ul {
 float: left;
}

.tower-crane ul:first-child {
 margin-right: 150px;
}

.tower-crane ul li {
 font-size: 18px;
 padding: 20px;
}

</style>